export const MANAGE = 'manage';
export const READ = 'read';
export const CREATE = 'create';
export const UPDATE = 'update';
export const DELETE = 'delete';
export const CHANGE_PUBLISHING_STATE = 'change_publishing_state';
export const ACCESS = 'access';
export const CHANGE_VIEW_FOR = 'change_view_for';
export const CONTROL = 'control';
